// export default 'http://training.semesteratsea.org/api';
// export default 'http://stagingadmin.semesteratsea.org/api';
export default '/api';



// WEBPACK FOOTER //
// ./src/apiPath.js